module.exports = __webpack_public_path__ + "img/ayun-quantity-based-screens.a97d5977.svg";